import { graphql } from "@opensea/graphql"
import { CollectionSweepQuoteReceiptFragment } from "../../../components/CollectionSweepQuoteReceipt/CollectionSweepQuoteReceipt.fragment"
import { CollectionSweepReceiptFragment } from "./components/CollectionSweepReceipt/CollectionSweepReceipt.fragment"
import { CollectionSweepStatus_quoteFragment } from "./components/CollectionSweepStatus/CollectionSweepStatus.fragment"
import { CollectionSweepFlowTimeline_quoteFragment } from "./components/CollectionSweepTimeline/CollectionSweepTimeline.fragment"

export const CollectionSweepFlow_quoteFragment = graphql(
  `
    fragment CollectionSweepFlow_quote on CollectionSweepQuoteResponse {
      collection {
        imageUrl
      }

      ...CollectionSweepQuoteReceipt
      ...CollectionSweepFlowTimeline_quote
      ...CollectionSweepStatus_quote
      ...CollectionSweepReceipt
    }
  `,
  [
    CollectionSweepQuoteReceiptFragment,
    CollectionSweepFlowTimeline_quoteFragment,
    CollectionSweepStatus_quoteFragment,
    CollectionSweepReceiptFragment,
  ],
)
